import { render, staticRenderFns } from "./GJ.vue?vue&type=template&id=2fadee7e&scoped=true"
import script from "./GJ.vue?vue&type=script&lang=js"
export * from "./GJ.vue?vue&type=script&lang=js"
import style0 from "./GJ.vue?vue&type=style&index=0&id=2fadee7e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fadee7e",
  null
  
)

export default component.exports